// extracted by mini-css-extract-plugin
export default {"modalTitle":"d1I7zk7l","headerTitle":"H9Lad66W","headerTitle__badge":"bolNt7zx","headerTitleBadge":"bolNt7zx","warning":"jRhOEtJ4","headerDate":"xfUF2CQz","scamImage":"sQHnH_Ht"};